import { LitElement } from 'lit';
import { TemplatingMixin } from '@common/lit/mixins/TemplatingMixin.js';
import { TriggerEventMixin } from '@common/lit/mixins/TriggerEventMixin.js';
import { templates } from '@src/components/templates/index.js';
import { config } from '@src/config/index.js';
import { configStore } from '@src/store/index.js';

export const BaseComponent = TemplatingMixin(
  TriggerEventMixin(LitElement, config.componentTagName),
  configStore.theme,
  templates,
);
